<template>
  <Protect
    :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_READ]"
    :skip-protect="isInCurrentWorkspace"
  >
    <h1
      class="text-[24px] md:text-[30px] font-normal md:font-thin text-white mb-10 px-12 md:px-0"
    >
      Projects
    </h1>
    <ProjectsView />
    <template #fallback>
      <NoAccess />
    </template>
  </Protect>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Protect from '@/hoc/Protect.vue';
import ProjectsView from '@features/workspaces/ProjectsView.vue';

import { SYS_PERMISSIONS } from '@/constants.js';
import NoAccess from '@components/common/NoAccess.vue';

const store = useStore();

const isInCurrentWorkspace = computed(
  () => store.getters['user/externalMemberships/isInCurrentWorkspace']
);
</script>
